import { createAsyncThunk } from "@reduxjs/toolkit";
import dayjs from "dayjs";

import { postData } from "../../apiservice/apis";

export const fetchCrmReport = createAsyncThunk(
  "crmReport/fetch",

  async (filters = {}, { rejectWithValue }) => {
    try {
      const payload = {
        reportType: filters.reportType || "source",

        source_id:
          filters.reportType === "combined"
            ? filters.source_id || null
            : null,

        status_id:
          filters.reportType === "combined"
            ? filters.status_id || null
            : null,

        purpose_id:
          filters.reportType === "combined"
            ? filters.purpose_id || null
            : null,

        fromDate: filters.fromDate
          ? dayjs(filters.fromDate)
              .startOf("day")
              .format("YYYY-MM-DD HH:mm:ss")
          : null,

        toDate: filters.toDate
          ? dayjs(filters.toDate)
              .endOf("day")
              .format("YYYY-MM-DD HH:mm:ss")
          : null,
      };

      const res = await postData(
        "/crm/reports/leads",
        payload
      );

      console.log("CRM REPORT PAYLOAD:", payload);
      console.log("CRM REPORT RESPONSE:", res.data);

      return {
        data: res.data?.data || [],
        totalLeads: Number(
          res.data?.totalLeads || 0
        ),
      };
    } catch (err) {
      return rejectWithValue(
        err.response?.data || err.message
      );
    }
  }
);